import { useSelector } from 'react-redux';
import { Tooltip, Typography } from '@mui/material';
import { selectOccupancyStats } from '@/features/project/unitStatusSelectors';

export function OccupancyStatsHeader() {
  // Folded from the project's `state_*` status events, falling back to the
  // lease for units with no recorded move-in/move-out — the same resolution the
  // per-unit badges use, so these totals always agree with the rows below.
  const { total, occupied, vacant, withStatusEvents } = useSelector(selectOccupancyStats);

  return (
    <div className="w-full flex items-center justify-center gap-12">
        <div className="flex items-center gap-2">
          <Typography variant="body2" color="textSecondary" className='text-sm'>Total:</Typography>
          <Typography variant="h6" className='text-sm'>{total}</Typography>
        </div>
        <div className="flex items-center gap-2">
          <Typography variant="body2" color="textSecondary" className='text-sm'>Occupied:</Typography>
          <Typography variant="h6" className="text-green-400 text-sm">{occupied}</Typography>
        </div>
        <div className="flex items-center gap-2">
          <Typography variant="body2" color="textSecondary" className='text-sm'>Vacant:</Typography>
          <Typography variant="h6" className="text-red-400 text-sm">{vacant}</Typography>
        </div>
        {total > 0 && withStatusEvents < total && (
          <Tooltip
            title={`${total - withStatusEvents} of ${total} units have no recorded status events yet — their occupancy is inferred from the lease.`}
          >
            <Typography variant="body2" color="textSecondary" className="text-sm cursor-help">
              Tracked: {withStatusEvents}/{total}
            </Typography>
          </Tooltip>
        )}
      </div>
  );
}
